import React from 'react';
import { withTranslation } from 'react-i18next';
import './BrandCard.sass';

class BrandCard extends React.Component {
  state = {
    isFullText: false
  }
  #image;
  #imageAlt;
  #short;
  #content;
  #noExpand;
  #cardRef = React.createRef();
  #contentRef = React.createRef();

  constructor (props) {
    super(props);
    this.#image = props.image;
    this.#imageAlt = props.imageAlt;
    this.#short = props.short;
    this.#content = props.content;
    this.#noExpand = props.noExpand || false;
  }

  #parseToHTML(text) {
    return text.split("\n").map((line, index) => <p key={index}>{line}</p>);
  }

  componentDidMount () {
    this.#contentRef.current.innerHTML = this.#content;
  }

  render () {
    const { t } = this.props;
    return (
      <div className="BrandCard section__block section__block--border" ref={this.#cardRef}>
        <div className="w100">
          <div className="w100 flex justify-center">
            <img src={this.#image} alt={this.#imageAlt} />
          </div>
          <p className="BrandCard__title">
          {
            this.#short
          }
          </p>
          {
            <div className={`BrandCard__absolute ${this.#noExpand ? 'BrandCard__absolute--no-expand' : ''}`}>
              <p ref={this.#contentRef}>
              </p>
              { !this.#noExpand && (
                <div className="w100 flex justify-center">
                  <input type="button" value={t("less")} onClick={this.#onShowLess} className="BrandCard__button button--primary" />
                </div>
              )}
            </div>
          }
        </div>
        { !this.#noExpand && (
          <div className="w100 flex justify-center">
            <input type="button" value={t("more")} className="BrandCard__button button--primary" onClick={this.#onShowMore} />
          </div>
        )}
      </div>
    )
  }

  #onShowMore = () => {
    this.#onShowLess();
    this.#cardRef.current.classList.add("BrandCard--expanded");
  }

  #onShowLess = () => {
    document.querySelectorAll(".BrandCard--expanded").forEach(elem => {
      elem.classList.toggle("BrandCard--expanded");
    });
  }
}

export default withTranslation()(BrandCard)
